module.exports = __webpack_public_path__ + "static/media/7@1280w.0d7d1b00.jpg";